<template>
  <div
    ref="wrap"
    :class="modernBrowser ? 'justify-space' : 'justify-center'"
    class="input-wrap"
  >
    <template v-if="modernBrowser">
      <template v-for="(char, index) in valueParts">
        <input
          :key="index"
          :autofocus="autofocus"
          autocomplete="off"
          v-bind="$attrs"
          ref="input"
          v-model="valueParts[index]"
          @keyup="handleEnterKey($event); handleKeyDown($event, index)"
          @input="handleInput($event, index)"
          @paste="onPaste"
          type="number"
          inputmode="numeric"
          maxlength="1"
          class="box"
          size="lg"
      />
      </template>
    </template>
    <input
      v-else
      @keyup="handleEnterKey($event)"
      v-bind="$attrs"
      :value="value"
      v-on:input="$emit('input', $event.target.value)"
      type="number"
      :maxlength="CODE_LENGTH"
      :onkeypress="'if(this.value.length===' + CODE_LENGTH + ') return false;'"
      class="fallback"
      size="lg"
    />
  </div>
</template>

<script>
// const CODE_LENGTH = 9;
const modernBrowser = true; // removed detection dependenncy

export default {
  name: 'CodeInput',
  template: `

  
  
  `,
  inheritAttrs: modernBrowser,
  props: {
    value: {
      type: String,
      default: '',
      
    },
    autofocus: Boolean,
    CODE_LENGTH : Number,
  },
  data() {
    return {
      modernBrowser,
      valueParts: _fill([], '', this.CODE_LENGTH),
      delimiter: this.CODE_LENGTH / 2 - 1,
      protect: false, // multipress protection
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      };
    },
  },
  watch: {
    valueParts() {
      this.emitInput();
    },
  },
  mounted() {
    if (this.$refs.input[0].autofocus) {
      this.focus(0);
    }
  },
  methods: {
    focus(index) {
      if (index > this.delimiter) {
        // index++;
      }
      const inp = this.$refs.wrap.children[index];
      if (inp) {
        inp.focus();
      }
    },
    handleEnterKey(event) {
      // handle Enter key submit since "onKeyPress="if(this.value.length" prevents thisdefault action
      if (event.key === 'Enter') {
        this.$emit('enter');
        event.stopPropagation();
      }
    },
    handleKeyDown(event, index) {
      // handle "Unindentified" as undefined
      const key = _sanitizeEventKey(event.key);
      if (!key) {
        return;
      } else if (key === 'Backspace') {
        if (this.valueParts[index]) {
          return (this.valueParts[index] = '');
        }
        this.focus(index - 1);
      } else if (!event.shiftKey && (key === 'ArrowRight' || key === 'Right')) {
        this.focus(index + 1);
      } else if (!event.shiftKey && (key === 'ArrowLeft' || key === 'Left')) {
        this.focus(index - 1);
      } else if (key.length === 1 && this.valueParts[index]) {
        this.valueParts[index] = key;
        this.$forceUpdate();
        this.focus(index + 1);
        this.emitInput();
      }
    },
    handleInput(event, index) {
      const value = this.valueParts[index];

      if (value) {
        if (value.length > 1) {
          this.valueParts[index] = value[value.length - 1];
        }
        this.focus(index + 1);
      }

      this.emitInput();
    },
    onPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) {
        return;
      }
      // IE fix
      event.preventDefault();
      const code =
        clipboardData.getData('Text') || clipboardData.getData('text/plain');
      this.fillCode(code);
    },
    fillCode(code) {
      code = code.trim();
      code = code.slice(0, this.CODE_LENGTH);
      const parts = code.split('');
      parts.length = this.CODE_LENGTH;
      this.valueParts = parts;

      const last = code.length - 1;
      setTimeout(() => {
        // cut out extra chars from last input
        this.valueParts[last] =
          this.valueParts[last] && this.valueParts[last].slice(0, 1); // apply just first char
        this.$forceUpdate();
        this.focus(last);
      }, 0);
    },
    emitInput() {
      const result = this.valueParts.join('').slice(0, this.CODE_LENGTH);
      this.$emit('input', result);
    },
  },
};

function _fill(arr, val, l) {
  arr.length = l;
  arr.fill(val, 0, l);
  return arr;
}

function _sanitizeEventKey(key) {
  return key === 'Unidentified' ? undefined : key;
}

</script>

<style lang="scss" scoped>
.input-wrap {
  display: flex;
  // width: 50%;
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  /* align-items: center; */
  /* margin: 1rem 0.3rem; */
}
.justify-space {
  justify-content: space-between;
  // justify-content: center;
}
.justify-center {
  justify-content: center;
}
.box, .fallback {
  display: inline-block;
  height: 54px;
  text-align: center;
  font-size: 200%;
  // margin: 10px;
  /* border: $border; */
  border: 1px solid #D7D7D7;
  box-shadow: 0px 2px 5px rgba(204, 211, 214, 0.5);
border-radius: 6px;
  &.empty {
    color: transparent;
  }
}
.box {
  max-width: 47px;
  // max-width:auto;
  padding: 0.3rem;
}
.fallback {
  max-width: 14rem;
  letter-spacing: 1rem;
}

input[type="number"]::-webkit-inner-spin-button, 
input[type="number"]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

</style>